import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { rtlModeAction, getRtlMode } from "../../../store/mode/rtlmode";
import { authSession, mustChangePassword, postLoginData, verifyFACode } from "../../../services/auth";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import logo from "../../../assets/images/logo.png";
import "./auth.css";
import { firstAllowedPath } from "../../../components/layout/menu";
import { can } from "../../../utils/roles";
const mapStateToProps = (state) => {
  return {
    rtlMode: getRtlMode(state),
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      rtlModeAction,
    },
    dispatch
  ),
});

const SignIn = (props) => {
  const { t } = useTranslation();
  // Temporary password (new account, reset): a reminder, never a blocker
  const remindTemporaryPassword = () => {
    if (mustChangePassword()) toast.info(t("You are using a temporary password. You can choose your own in My profile."));
  };
  const [otpPage, setOtpPage] = useState(false);
  useEffect(() => {
    const rtlMode = sessionStorage.getItem("rtl-mode");
    if (rtlMode === null) {
      props.rtlModeAction(props.rtlMode);
    } else {
      props.rtlModeAction(rtlMode);
    }
  });
  const isValidEmail = (email) => {
    // regular expression to validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const [error, setError] = useState("");
  const [showError, setShowError] = useState(false);

  const [emptyObj, setEmptyObj] = useState(false);
  let history = useHistory();
  const [formData, setFormData] = useState({});
  const [, setSessionData] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    if (!formData.email || !formData.password) {
      setEmptyObj(true);
      setTimeout(() => {
        setEmptyObj(false);
      }, 3000);
      return;
    }

    if (!isValidEmail(formData.email)) {
      setError("Invalid email address");
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 3000);
      return;
    }
    // postLoginData(formData, history, setShowError, setError);
    // setOtpPage(true);

    try {
      await postLoginData(formData);
      const result1 = await authSession();
      if (result1) {
        // get session data for phone number
        await setSessionData(localStorage.getItem("session"));

        // First page this admin can open

        history.push(firstAllowedPath(can));
        remindTemporaryPassword();
      } else {
        // history.push("/auth/login");
      }
      // setOtpPage(true);
    } catch (error) {
      console.error(error);
      setError("Invalid Email or password");
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
      }, 3000);
    }
  };

  // verfification code - OTP
  const [verificationCode, setVerificationCode] = useState("");
  const [wrongCode, setWrongCode] = useState(false);
  const verifyCode = async () => {
    const verifyObj = {
      email: formData.email,
      code: verificationCode,
      token: localStorage.getItem("2fatoken"),
    };
    try {
      const result = await verifyFACode(verifyObj);
      if (result) {
        // no need for authsession here. do this instead:
        localStorage.removeItem("2fatoken");

        try {
          await postLoginData(formData);
          console.log(formData);
          const result1 = await authSession();
          if (result1) {
            // get session data for phone number
            await setSessionData(localStorage.getItem("session"));
            setOtpPage(false);
            // First page this admin can open
            history.push(firstAllowedPath(can));
        remindTemporaryPassword();
          } else {
            // history.push("/auth/login");
          }
        } catch (error) {
          console.error(error);
          setError("Invalid Email or password");
          setShowError(true);
          setTimeout(() => {
            setShowError(false);
          }, 3000);
        }
      } else {
        setWrongCode(true);
        setTimeout(() => {
          setWrongCode(false);
        }, 3000);
      }
    } catch (error) {
      setWrongCode(true);
      setTimeout(() => {
        setWrongCode(false);
      }, 3000);
    }
  };
  // Display only: the login logic above is unchanged.
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  // A successful login leaves this page before the request ends.
  const mounted = useRef(true);
  useEffect(() => () => (mounted.current = false), []);
  const submit = async (event) => {
    setSubmitting(true);
    try {
      await handleLogin(event);
    } finally {
      if (mounted.current) setSubmitting(false);
    }
  };
  const alert = showError ? t(error) : emptyObj ? t("Enter email and password") : "";

  return (
    <section className="auth-page">
      <div className="auth-brand" aria-hidden="true">
        <img src={logo} alt="" className="auth-brand-logo" />
        <h2>{t("Administration")}</h2>
        <p>{t("Manage the catalogue, the users and the apps of AFO MEDIA.")}</p>
      </div>

      <div className="auth-panel">
        <img src={logo} alt="AFO MEDIA" className="auth-logo" />
        {!otpPage ? (
          <form className="auth-card" onSubmit={submit} noValidate>
            <h1>{t("Sign in")}</h1>
            <p className="auth-hint">{t("Use your administrator account.")}</p>
            {alert && (
              <div className="auth-alert" role="alert">
                <i className="ri-error-warning-line" aria-hidden="true"></i>
                {alert}
              </div>
            )}
            <label className="auth-field">
              <span>{t("Email Address")}</span>
              <input
                type="email"
                placeholder="youremail@example.com"
                autoComplete="username"
                required
                value={formData.email || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  })
                }
              />
            </label>
            <label className="auth-field">
              <span>{t("Password")}</span>
              <span className="auth-password">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder={t("Your password")}
                  autoComplete="current-password"
                  required
                  value={formData.password || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      password: e.target.value,
                    })
                  }
                />
                <button
                  type="button"
                  className="auth-eye"
                  aria-label={showPassword ? t("Hide password") : t("Show password")}
                  onClick={() => setShowPassword((shown) => !shown)}
                >
                  <i
                    className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}
                    aria-hidden="true"
                  ></i>
                </button>
              </span>
            </label>
            <button type="submit" className="auth-submit" disabled={submitting}>
              {submitting && <span className="auth-spinner" aria-hidden="true" />}
              {t("Login")}
            </button>
          </form>
        ) : (
          <div className="auth-card">
            <h1>{t("Enter OTP")}</h1>
            <p className="auth-hint">{t("Enter the 6-digit code you received.")}</p>
            <div className="auth-otp">
              <OtpInput
                value={verificationCode}
                onChange={setVerificationCode}
                numInputs={6}
                renderInput={(inputProps) => (
                  <input {...inputProps} className="auth-otp-input" />
                )}
                renderSeparator={<span className="auth-otp-gap" />}
              />
            </div>
            {wrongCode && (
              <div className="auth-alert" role="alert">
                <i className="ri-error-warning-line" aria-hidden="true"></i>
                {t("Please Enter Correct OTP")}
              </div>
            )}
            <button type="button" className="auth-submit" onClick={verifyCode}>
              {t("Verify")}
            </button>
          </div>
        )}
        <p className="auth-footer">© {new Date().getFullYear()} AFO MEDIA</p>
      </div>
    </section>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
